/* eslint no-restricted-globals:0 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  Paper,
} from '@material-ui/core';
import MailIcon from '@material-ui/icons/Mail';
import CallIcon from '@material-ui/icons/Call';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '18px',
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '20px',
      textAlign: 'left',
      margin: '0 auto',
      [theme.breakpoints.down('lg')]: {
        width: '90%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '70%',
      },
      '& > h1': {
        marginTop: '0px',
        color: '#0e419b',
        textAlign: 'center'
      },
    },
  },
  price: { 
    textAlign: 'center',
  },
  underline: {
    borderBottom: '2px solid #c5cae9',
  },
  icon: {
    verticalAlign: 'middle',
    display: 'inline',
    marginRight: '10px'
  },
  mail: {
    margin: '0px'
  },
  [theme.breakpoints.down('xs')]: {
    adr: {
      fontSize: '14px'
    },
    comname: {
      fontSize: '16px'
    },
    spbr: {
      display:'block'
    }
  },
  [theme.breakpoints.up('xs')]: {
    spbr: {
      display:'none'
    }
  },
  
}));

const Price = props => {

  const classes = useStyles();

  return (
    <div className={classes.root}>

    <Paper elevation={3}>
      <h1>導入に関するお問い合わせ</h1>
      <div className={classes.price}>
        <p>下記までお気軽にお問い合わせください。</p>
        <div className={classes.underline} />　{/* 下線 */}
        <div>
          {/* <p>株式会社DRAGON AGENCY</p><br className={classes.spbr} /><p style={{paddingLeft: "10px", display:'inline'}}>営業部</p> */}
          <p className={classes.comname}>株式会社DRAGON AGENCY　営業部</p>
        </div>
        <br />
        <div>
          <CallIcon color="primary" className={classes.icon} />
            <a href="tel:0525695230" className={classes.adr}>052-569-5230</a>
        </div>
        <div>
          <MailIcon color="primary" className={classes.icon} />
          <a href="mailto:sales-information@connectcompass.net?subject=【CONNECTCOMPASS】お問い合わせ&amp;body=" className={classes.adr}>sales-information@connectcompass.net</a>
        </div>
        <br />
      </div>
      
    </Paper>
  </div>
  );
}

Price.propTypes = {
    className: PropTypes.string,
  }

export default Price;